'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function useIntercom(appID) {
  var userData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loaded = _React$useState2[0],
      setLoaded = _React$useState2[1];

  var email = userData.email,
      user_id = userData.user_id;


  React.useEffect(function () {
    if (!window.Intercom) {
      // this snipet comes from
      // intercom
      (function (w, d, id, s, x) {
        function i() {
          i.c(arguments);
        }
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        s = d.createElement("script");
        s.async = 1;
        s.src = "https://widget.intercom.io/widget/" + id;
        d.head.appendChild(s);
      })(window, document, appID);
    }

    return function () {
      if (window.Intercom) {
        window.Intercom("shutdown");
        setLoaded(false);
        window.Intercom = null;
      }
    };
  }, [appID, email, user_id]);

  React.useEffect(function () {
    if (window.Intercom) {
      if (loaded) {
        window.Intercom("update", _extends({ app_id: appID }, userData));
      } else {
        window.Intercom("boot", _extends({ app_id: appID }, userData));
        setLoaded(true);
      }
    }
  }, [appID, userData]);
}

module.exports = useIntercom;
